export default "__VITE_ASSET__DUsZClbl__"